module.exports = __webpack_public_path__ + "img/trends_10.aa6d42ec.jpg";